module.exports = __webpack_public_path__ + "img/w16-b2.a65cf994.jpg";